export const AccessDenied = () => {
  return (
    <div style={{ padding: 24 }}>
      <h1>Доступ запрещён</h1>
      <p>У вашей роли нет доступа к этой странице.</p>
    </div>
  );
};
